/**
 * ChainPresetSelectorWrapper Component
 * Wrapper for Chain Preset Selector modal
 */

import React from 'react';
import { ChainPresetSelector } from '../plugins';

export const ChainPresetSelectorWrapper = ({
  isOpen,
  onClose,
  currentChain,
  onLoadPreset,
  onSavePreset,
  userId,
}) => {
  return (
    <ChainPresetSelector
      isOpen={isOpen}
      onClose={onClose}
      currentChain={currentChain}
      onLoadPreset={onLoadPreset}
      onSavePreset={onSavePreset}
      userId={userId}
    />
  );
};

export default ChainPresetSelectorWrapper;
